document.addEventListener("DOMContentLoaded", function () {
  new Splide("#collection-carousel", {
    perPage: 4,
    height: "auto",
    autoWidth:true,
    type: "loop",
    perMove: 1,
    loop: true,
    breakpoints: {
      450: {
        perPage: 1,
      },
      630: {
        perPage: 2,
      },
    },
  }).mount();
});
